<template>
  <div id="projectAdd">
    <ul class="leftBar">
      <li @click="sideBarClick('1')" :class="activeLeftBar=='1'? 'projectLeftBarActive' : ''">过控</li>
      <li @click="sideBarClick('5')" :class="activeLeftBar=='5'? 'projectLeftBarActive' : ''">财务</li>
      <li @click="sideBarClick('2')" :class="activeLeftBar=='2'? 'projectLeftBarActive' : ''">文件</li>
      <!-- <li @click="sideBarClick('3')" :class="activeLeftBar=='3'? 'projectLeftBarActive' : ''">统计</li> -->
      <li @click="sideBarClick('4')" :class="activeLeftBar=='4'? 'projectLeftBarActive' : ''">日志</li>
    </ul>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeLeftBar: '1',
      details_project_id: '',
      details_project_status: '',
      isEdit: '1',
      details_project_name: '',
      details_project_code: '',
      details_company_name: '',
    }
  },
  methods: {
    sideBarClick(val) {
      if (this.isEdit == '0') return
      this.activeLeftBar = val
      if (val === '1') {
        this.$router.push({
          path: '/project/details/task',
          query: {
            project_id: this.details_project_id,
            project_status: this.details_project_status,
            project_name: this.details_project_name,
            project_code: this.details_project_code,
            company_name: this.details_company_name,
            isEdit: '1',
          },
        })
      } else if (val === '2') {
        this.$router.push({
          path: '/project/details/file',
          query: {
            project_id: this.details_project_id,
            project_status: this.details_project_status,
            project_name: this.details_project_name,
            project_code: this.details_project_code,
            company_name: this.details_company_name,
            isEdit: '1',
          },
        })
      } else if (val === '3') {
        this.$router.push({
          path: '/project/details/statistics',
          query: {
            project_id: this.details_project_id,
            project_status: this.details_project_status,
            project_name: this.details_project_name,
            project_code: this.details_project_code,
            company_name: this.details_company_name,
            isEdit: '1',
          },
        })
      } else if (val === '4') {
        this.$router.push({
          path: '/project/details/logs',
          query: {
            project_id: this.details_project_id,
            project_status: this.details_project_status,
            project_name: this.details_project_name,
            project_code: this.details_project_code,
            company_name: this.details_company_name,
            isEdit: '1',
          },
        })
      } else if (val === '5') {
        this.$router.push({
          path: '/project/details/finance',
          query: {
            project_id: this.details_project_id,
            project_status: this.details_project_status,
            project_name: this.details_project_name,
            project_code: this.details_project_code,
            company_name: this.details_company_name,
            isEdit: '1',
            isFromProjectSideBar: '1',
          },
        })
      }
    },
  },
  created() {
    if (this.$route.path == '/project/details/task') {
      this.activeLeftBar = '1'
    }
    if (this.$route.path == '/project/details/file') {
      this.activeLeftBar = '2'
    }
    if (this.$route.path == '/project/details/statistics') {
      this.activeLeftBar = '3'
    }
    if (this.$route.path == '/project/details/logs') {
      this.activeLeftBar = '4'
    }
    if (this.$route.path == '/project/details/finance') {
      this.activeLeftBar = '5'
    }
    if (this.$route.path == '/project/add/task') {
      this.isEdit = '0'
    }
    this.details_project_id = this.$route.query.project_id || ''
    this.details_project_status = this.$route.query.project_status || ''
    this.details_project_name = this.$route.query.project_name || ''
    this.details_project_code = this.$route.query.project_code || ''
    this.details_company_name = this.$route.query.company_name || ''
  },
}
</script>
<style lang="less" scoped>
#projectAdd {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  .leftBar {
    width: 120px;
    height: 100%;
    background-color: #fff;
    li {
      cursor: pointer;
      width: 100%;
      height: 95px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 700;
      color: #666;
    }
    .projectLeftBarActive {
      background-color: #e4f3ff;
      color: #128bf1;
    }
  }
}
#projectIndex {
  // *修改tabs样式
  /deep/.el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }
  /deep/.el-tabs {
    width: 100%;
    height: calc(100% - 68px);
    .el-tabs__header {
      width: 100%;
      margin-bottom: 20px;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav-scroll {
          width: 100%;
          .el-tabs__nav {
            box-sizing: border-box;
            padding-left: 40px;
            width: 100%;
          }
        }
      }
    }
    .el-tabs__content {
      height: calc(100% - 80px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/.el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    padding-right: 100px;
    // width: 17%;
  }
  /deep/.el-tabs__item.is-active {
    color: #333 !important;
  }
  /deep/.el-tabs__item:hover {
    color: #333 !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    color: #999999;
  }
  // *修改tabs样式
}

// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
</style>
